import React from 'react';
import './Facts.less';

class Facts extends React.Component {
  render () {
    return (
      <section className="section section-facts">
        <div className="container container-limit grid-sm-2">
          <article className="story">
            <h1>Dla czego bOrszcz?</h1>
              <p>Barszcz nie od dziś gości na Państwa stołach.<br/>
                Nasz borszcz jest przygotowywany według receptury <strong>kuchni wschodniej</strong>.</p>
              <p>Stąd też nasz borszcz nie może być nazywany barszczem.</p>
          </article>
          <article className="story">
            <h1>Szybkość</h1>
            <p>Dostarczamy w wyznaczonej strefie w ciągu <strong>60 min.</strong></p>
            <p>
              Zamowisz to bespośrednio u nas na stronie.
              Plac gotowką albo kartą.
            </p>
          </article>
        </div>
      </section>
    );
  }
}

export default Facts;



// WEBPACK FOOTER //
// ./src/components/Facts/Facts.js